import { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const navLinks = [
  { name: '首页', path: '/' },
  { name: '课程', path: '/courses' },
  { name: '作品展示', path: '/gallery' },
  { name: '师资介绍', path: '/about' },
  { name: '教学文章', path: '/articles' },
  { name: '联系我们', path: '/contact' },
]

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <motion.img
              whileHover={{ scale: 1.05 }}
              src="/logo.png"
              alt="王老师烘焙"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <h1 className="font-display text-xl text-chocolate font-semibold">王老师烘焙</h1>
              <p className="text-xs text-caramel">专业西点培训20年</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-chocolate hover:text-caramel transition-colors font-medium relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-caramel transition-all group-hover:w-full" />
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <Link to="/contact" className="hidden md:block btn-primary">
            预约咨询
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-chocolate"
            aria-label="菜单"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.nav
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden py-4 border-t border-caramel/20"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-chocolate hover:text-caramel transition-colors font-medium py-2"
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/contact" className="btn-primary text-center">
                预约咨询
              </Link>
            </div>
          </motion.nav>
        )}
      </div>
    </header>
  )
}